function iFrameResize($iFrame, options)
{
  if ($iFrame instanceof HTMLElement) {
    $iFrame = $($iFrame);
  }
  options          = options || {};
  var loaded       = $iFrame.data("iframe-resize-loaded") || options.loaded || false;
  var attemptCount = $iFrame.data("iframe-resize-attempt") || 0;
  var bound        = $iFrame.data("iframe-resize-bound");
  var timeout      = $iFrame.data("iframe-resize-timeout");

  if (options.rebind) {
    bound = false;
  }

  options.direction = options.direction || $iFrame.data("iframe-resize-expand-direction") || "down";
  options.container = options.container || $iFrame.data("iframe-resize-scroller") || false;
  options.minHeight = options.minHeight || $iFrame.data("iframe-min-height") || 300;


  if (typeof $iFrame.data("iframe-resize-expand-direction") === "undefined") {
    $iFrame.data("iframe-resize-expand-direction", options.direction);
  }

  if (typeof $iFrame.data("iframe-resize-scroller") === "undefined" && options.container !== false) {
    $iFrame.data("iframe-resize-scroller", options.container);
  }

  if (typeof timeout !== "undefined") {
    clearTimeout(timeout);
  }

  if (loaded) {
    $iFrame.data("iframe-resize-loaded", true);
  }
  var oldHeight;
  if (typeof bound === "undefined" || !bound) {
    $iFrame.data("iframe-resize-bound", true);
    oldHeight = options.minHeight;
    $iFrame.height(oldHeight);
    $iFrame.on("load", function() {
      iFrameResize($iFrame, {loaded: true});
    });
  }
  else {
    oldHeight = parseInt($iFrame.height());
  }

  var $html = $iFrame.contents().find("html");
  var $body = $html.find("body");
  if (!$body.length) {
    $body = $html;
  }
  $body.css({"height": "auto", "overflow-y": "hidden"});
  $html.css({"height": "auto", "overflow-y": "hidden"});


  var htmlScrollHeight = 0;
  var bodyScrollHeight = 0;
  var htmlHeight       = 0;
  var bodyHeight       = 0;
  if ($html.length) {
    htmlScrollHeight = parseInt($html[0].scrollHeight);
    htmlHeight       = parseInt($html.height());
  }
  if ($body.length) {
    bodyScrollHeight = parseInt($body[0].scrollHeight);
    bodyHeight       = parseInt($body.height());
  }


  var newHeight = Math.max(htmlScrollHeight, bodyScrollHeight, htmlHeight, bodyHeight);
  if (!isNaN(oldHeight) && !isNaN(newHeight)) {
    if (options.container !== false && options.direction === "up") {
      var scroller = $iFrame.closest(options.container);
      if (scroller.length) {
        var newScroll = scroller.scrollTop() + parseInt(newHeight) - parseInt(oldHeight);
      }
    }

    $iFrame.height(newHeight);


    if (typeof scroller !== "undefined" && scroller.length && options.direction === "up") {
      scroller.scrollTop(newScroll);
    }
  }

  if (loaded) {
    return true;
  }
  attemptCount++;

  // try to adjust size of iframe for 2 seconds. (give up after that, it's taking too long to load)
  if (attemptCount > 20) {
    return true;
  }

  $iFrame.data("iframe-resize-attempt", attemptCount);

  timeout = setTimeout(function() {
    iFrameResize($iFrame);
  }, 100);
  $iFrame.data("iframe-resize-timeout", timeout);
}

